module.exports = __webpack_public_path__ + "static/tiktok_logo-6535f0b6995a25638f715ab9f1349262.png";